/** Oro MX chrome copy. Merged into the shared catalogs; not used by BR/US skins. */
export const oroMxI18n: Record<string, Record<string, string>> = {
  'es-MX': {
    'oro.tab.menu': 'Menú',
    'oro.tab.casino': 'Casino',
    'oro.tab.deposit': 'Depositar',
    'oro.tab.activity': 'Actividad',
    'oro.tab.profile': 'Perfil',
    'oro.nav.aria': 'Navegación',
    'oro.menu.close': 'Cerrar menú',
    'oro.menu.casino': 'Casino',
    'oro.menu.vip': 'Sistema de niveles VIP',
    'oro.menu.promo': 'promociones',
    'oro.menu.affiliate': 'Centro de afiliados',
    'oro.menu.telegram': 'Telegram',
    'oro.menu.chat': 'Chat en Línea',
    'oro.lobby.lobby': 'Lobby',
    'oro.lobby.estudios': 'Estudios',
    'oro.lobby.providers': 'Proveedores',
    'oro.lobby.games': 'Juegos',
    'oro.lobby.all': 'Todos',
    'oro.lobby.favoritos': 'Favoritos',
    'oro.lobby.popular': 'Popular',
    'oro.lobby.popular-alt': 'Popular',
    'oro.lobby.nuevos': 'Nuevos',
    'oro.lobby.slots': 'Slots',
    'oro.lobby.live': 'Live Casino',
    'oro.lobby.sports': 'Sports',
    'oro.lobby.fishing': 'Pesca',
    'oro.header.login': 'Iniciar sesión',
    'oro.header.register': 'Registrarse',
    'oro.header.deposit': 'Depositar',
    'oro.header.profile': 'Perfil',
    'oro.header.redeem': 'Código de canje',
    'oro.footer.related': 'Enlaces relacionados',
    'oro.footer.about': 'sobre nosotros',
    'oro.footer.related.vip': 'Club VIP',
    'oro.footer.related.pwa': 'Cómo añadir a la pantalla de inicio',
    'oro.footer.about.rules': 'Reglas de usuario',
    'oro.footer.about.privacy': 'Política de Privacidad',
    'oro.footer.about.disclaimer': 'Deslinde de Responsabilidad',
    'oro.footer.about.kyc': 'Política de Verificación de Identidad (KYC)',
    'oro.footer.about.aml': 'Política Antilavado de Dinero',
    'oro.footer.legal':
      'Queda estrictamente prohibido el juego para menores de edad. Por favor, recuerde que el propósito principal de las apuestas es únicamente el entretenimiento y la diversión. orocasino.mx no está dirigido a niños ni a personas menores de 18 años. Si eres menor de 18 años (o no has alcanzado la mayoría de edad legal para apostar en tu país), por favor no ingreses a este sitio. Los menores deben obtener el permiso de sus padres antes de enviar cualquier información personal (como nombre, correo electrónico o teléfono) al sitio web. El juego puede ser adictivo, por favor juega de manera responsable. Para más información, visita nuestra página de [Juego Responsable].',
    'oro.footer.copyright':
      'Copyright ©2019-2024. Todos los derechos reservados. Todos los derechos reservados.',
    'oro.footer.app': 'application',
    'oro.footer.ios': 'For IOS',
    'oro.footer.android': 'For Android',
    'oro.profile.guest': 'Invitado',
    'oro.profile.vipClub': 'Club VIP',
    'oro.profile.depositAmount': 'Monto de depósito：',
    'oro.profile.betAmount': 'Monto de apuesta：',
    'oro.profile.deposit': 'Depósito',
    'oro.profile.withdraw': 'Retiro',
    'oro.profile.signOut': 'Cerrar sesión',
    'oro.profile.signIn': 'Iniciar sesión',
    'oro.profile.edit': 'Editar',
    'oro.profile.copy': 'Copiar',
    'oro.profile.copied': 'Copiado correctamente',
    'oro.profile.copyFail': 'Error al copiar',
    'oro.profile.back': 'Volver',
    'oro.profile.quick.tx': 'Transacciones',
    'oro.profile.quick.bets': 'Apuestas',
    'oro.profile.quick.moves': 'Movimientos',
    'oro.profile.menu.notify': 'Notificaciones',
    'oro.profile.menu.withdraw-account': 'Gestión de cuentas de retiro',
    'oro.profile.menu.offers': 'Mis ofertas',
    'oro.profile.menu.my-profile': 'Mi perfil',
    'oro.profile.menu.team': 'Centro de equipo',
    'oro.profile.menu.tickets': 'Ofertas',
    'oro.profile.menu.settings': 'Configuración',
    'oro.profile.menu.support': 'Chat en Línea',
    'oro.profile.menu.language': 'Idioma',
    'oro.auth.account': 'Ingresa tu cuenta',
    'oro.auth.phone': 'Ingresa 10 dígitos',
    'oro.auth.password': 'Ingresa tu contraseña',
    'oro.auth.promo': 'Código de invitación',
    'oro.auth.forgot': '¿Olvidaste tu contraseña?',
    'oro.auth.terms': 'Confirmo que tengo 18+ años y he leído los',
    'oro.auth.termsLink': 'Términos de Servicio',
    'oro.auth.gift': 'Regístrate y recibe un regalo',
    'oro.auth.giftLead': 'Recibe',
    'oro.auth.giftTail': 'Bonos',
    'oro.auth.hasAccount': '¿Ya tienes una cuenta?',
    'oro.auth.noAccount': '¿No tienes cuenta?',
    'oro.auth.orLogin': 'O inicia sesión con',
    'oro.auth.support': 'Soporte en vivo',
    'oro.auth.guest': 'Continuar modo prueba',
    'oro.guestBind.gift': 'Al vincular recibes {n} puntos',
    'oro.guestBind.ok': 'Vinculado',
    'oro.guestBind.hint': '6-16 caracteres. Después podrás entrar con este teléfono y contraseña.',
    'oro.guestBind.submit': 'Confirmar vínculo',
    'oro.guestBind.submitting': 'Vinculando',
    'oro.guestBind.close': 'Cerrar',
    'oro.auth.err.account': 'Ingresa tu cuenta',
    'oro.auth.err.password': 'La contraseña debe tener 6-16 caracteres',
    'oro.auth.err.phone': 'Ingresa un teléfono de 10 dígitos',
    'oro.auth.err.adult': 'Confirma que tienes 18+ años',
    'oro.auth.contactSupport': 'Por favor contacta a soporte',
    'oro.auth.googleUnavailable': 'Google no está disponible por ahora.',
    'oro.auth.smsLogin': 'Iniciar con código',
    'oro.auth.passwordLogin': 'Iniciar con contraseña',
    'oro.auth.smsCode': 'Ingresa el código',
    'oro.auth.sendCode': 'Enviar código',
    'oro.auth.smsFail': 'No se pudo enviar el código',
    'oro.auth.err.code': 'Ingresa el código',
    'oro.auth.err.codeLength': 'Ingresa el código de 6 dígitos',
    'auth.sessionExpired': 'Tu sesión ha expirado. Inicia sesión de nuevo.',
    'oro.lang.short.es-MX': 'MX',
    'oro.lang.short.en-US': 'EN',
    'oro.lang.short.zh-CN': '简',
    'oro.lang.short.zh-TW': '繁',
  },
  'en-US': {
    'oro.tab.menu': 'Menu',
    'oro.tab.casino': 'Casino',
    'oro.tab.deposit': 'Deposit',
    'oro.tab.activity': 'Promo',
    'oro.tab.profile': 'Profile',
    'oro.nav.aria': 'Navigation',
    'oro.menu.close': 'Close menu',
    'oro.menu.casino': 'Casino',
    'oro.menu.vip': 'VIP levels',
    'oro.menu.promo': 'Promotions',
    'oro.menu.affiliate': 'Affiliate center',
    'oro.menu.telegram': 'Telegram',
    'oro.menu.chat': 'Live chat',
    'oro.lobby.lobby': 'Lobby',
    'oro.lobby.estudios': 'Studios',
    'oro.lobby.providers': 'Providers',
    'oro.lobby.games': 'Games',
    'oro.lobby.all': 'All',
    'oro.lobby.favoritos': 'Favorites',
    'oro.lobby.popular': 'Popular',
    'oro.lobby.popular-alt': 'Popular',
    'oro.lobby.nuevos': 'New',
    'oro.lobby.slots': 'Slots',
    'oro.lobby.live': 'Live Casino',
    'oro.lobby.sports': 'Sports',
    'oro.lobby.fishing': 'Fishing',
    'oro.header.login': 'Log in',
    'oro.header.register': 'Sign up',
    'oro.header.deposit': 'Deposit',
    'oro.header.profile': 'Profile',
    'oro.header.redeem': 'Redeem code',
    'oro.footer.related': 'Related links',
    'oro.footer.about': 'About us',
    'oro.footer.related.vip': 'VIP Club',
    'oro.footer.related.pwa': 'Add to home screen',
    'oro.footer.about.rules': 'User rules',
    'oro.footer.about.privacy': 'Privacy policy',
    'oro.footer.about.disclaimer': 'Disclaimer',
    'oro.footer.about.kyc': 'Identity verification (KYC)',
    'oro.footer.about.aml': 'Anti-money laundering policy',
    'oro.footer.legal':
      'Gambling is strictly prohibited for minors. Please remember that betting is for entertainment only. orocasino.mx is not intended for children or anyone under 18. If you are under 18 (or below the legal gambling age in your country), do not enter this site. Minors must get parental permission before sending personal information (such as name, email, or phone) to the website. Gambling can be addictive; please play responsibly. For more information, visit our [Responsible Gaming] page.',
    'oro.footer.copyright': 'Copyright ©2019-2024. All rights reserved. All rights reserved.',
    'oro.footer.app': 'application',
    'oro.footer.ios': 'For IOS',
    'oro.footer.android': 'For Android',
    'oro.profile.guest': 'Guest',
    'oro.profile.vipClub': 'VIP Club',
    'oro.profile.depositAmount': 'Deposit amount:',
    'oro.profile.betAmount': 'Wager amount:',
    'oro.profile.deposit': 'Deposit',
    'oro.profile.withdraw': 'Withdraw',
    'oro.profile.signOut': 'Sign out',
    'oro.profile.signIn': 'Log in',
    'oro.profile.edit': 'Edit',
    'oro.profile.copy': 'Copy',
    'oro.profile.copied': 'Copied Successfully',
    'oro.profile.copyFail': 'Copy Failed',
    'oro.profile.back': 'Back',
    'oro.profile.quick.tx': 'Transactions',
    'oro.profile.quick.bets': 'Bets',
    'oro.profile.quick.moves': 'Movements',
    'oro.profile.menu.notify': 'Notifications',
    'oro.profile.menu.withdraw-account': 'Withdrawal accounts',
    'oro.profile.menu.offers': 'My offers',
    'oro.profile.menu.my-profile': 'My profile',
    'oro.profile.menu.team': 'Team center',
    'oro.profile.menu.tickets': 'Offers',
    'oro.profile.menu.settings': 'Settings',
    'oro.profile.menu.support': 'Live chat',
    'oro.profile.menu.language': 'Language',
    'oro.auth.account': 'Enter your account',
    'oro.auth.phone': 'Enter the 10-digit number',
    'oro.auth.password': 'Enter your password',
    'oro.auth.promo': 'Invite code',
    'oro.auth.forgot': 'Forgot your password?',
    'oro.auth.terms': 'I confirm I am 18+ and have read the',
    'oro.auth.termsLink': 'Terms of Service',
    'oro.auth.gift': 'Sign up and get a gift',
    'oro.auth.giftLead': 'Recibe',
    'oro.auth.giftTail': 'Bonos',
    'oro.auth.hasAccount': 'Already have an account?',
    'oro.auth.noAccount': "Don't have an account?",
    'oro.auth.orLogin': 'Or log in with',
    'oro.auth.support': 'Live support',
    'oro.auth.guest': 'Continue as guest',
    'oro.guestBind.gift': 'Bind to receive {n} points',
    'oro.guestBind.ok': 'Bound',
    'oro.guestBind.hint': '6-16 characters. You can then sign in with this phone and password.',
    'oro.guestBind.submit': 'Confirm binding',
    'oro.guestBind.submitting': 'Binding',
    'oro.guestBind.close': 'Close',
    'oro.auth.err.account': 'Enter your account',
    'oro.auth.err.password': 'Password must be 6-16 characters',
    'oro.auth.err.phone': 'Enter a 10-digit phone number',
    'oro.auth.err.adult': 'Confirm that you are 18+',
    'oro.auth.contactSupport': 'Please contact customer service',
    'oro.auth.googleUnavailable': 'Google sign-in is unavailable right now.',
    'oro.auth.smsLogin': 'Sign in with code',
    'oro.auth.passwordLogin': 'Sign in with password',
    'oro.auth.smsCode': 'Enter the code',
    'oro.auth.sendCode': 'Send code',
    'oro.auth.smsFail': 'Could not send the code',
    'oro.auth.err.code': 'Enter the code',
    'oro.auth.err.codeLength': 'Enter the 6-digit code',
    'auth.sessionExpired': 'Your session has expired. Please sign in again.',
    'oro.lang.short.es-MX': 'MX',
    'oro.lang.short.en-US': 'EN',
    'oro.lang.short.zh-CN': '简',
    'oro.lang.short.zh-TW': '繁',
  },
  'zh-CN': {
    'oro.tab.menu': '菜单',
    'oro.tab.casino': '娱乐场',
    'oro.tab.deposit': '存款',
    'oro.tab.activity': '活动',
    'oro.tab.profile': '我的',
    'oro.nav.aria': '导航',
    'oro.menu.close': '关闭菜单',
    'oro.menu.casino': '娱乐场',
    'oro.menu.vip': 'VIP 等级',
    'oro.menu.promo': '优惠',
    'oro.menu.affiliate': '代理中心',
    'oro.menu.telegram': 'Telegram',
    'oro.menu.chat': '在线客服',
    'oro.lobby.lobby': '大厅',
    'oro.lobby.estudios': '场馆',
    'oro.lobby.providers': '场馆',
    'oro.lobby.games': '游戏',
    'oro.lobby.all': '全部',
    'oro.lobby.favoritos': '收藏',
    'oro.lobby.popular': '热门',
    'oro.lobby.popular-alt': '热门',
    'oro.lobby.nuevos': '新品',
    'oro.lobby.slots': '老虎机',
    'oro.lobby.live': '真人',
    'oro.lobby.sports': '体育',
    'oro.lobby.fishing': '捕鱼',
    'oro.header.login': '登录',
    'oro.header.register': '注册',
    'oro.header.deposit': '存款',
    'oro.header.profile': '我的',
    'oro.header.redeem': '兑换码',
    'oro.footer.related': '相关链接',
    'oro.footer.about': '关于我们',
    'oro.footer.related.vip': 'VIP 俱乐部',
    'oro.footer.related.pwa': '添加到主屏幕',
    'oro.footer.about.rules': '用户规则',
    'oro.footer.about.privacy': '隐私政策',
    'oro.footer.about.disclaimer': '免责声明',
    'oro.footer.about.kyc': '身份验证政策（KYC）',
    'oro.footer.about.aml': '反洗钱政策',
    'oro.footer.legal':
      '严禁未成年人赌博。请记住，投注仅供娱乐。orocasino.mx 不面向儿童或未满 18 岁的人士。如果未满 18 岁（或未达到所在国家/地区的法定博彩年龄），请勿进入本站。未成年人在提交任何个人信息（如姓名、邮箱或电话）前须获得父母许可。博彩可能致瘾，请理性游戏。欲了解更多信息，请访问我们的[负责任博彩]页面。',
    'oro.footer.copyright': 'Copyright ©2019-2024. 保留所有权利。保留所有权利。',
    'oro.footer.app': '应用',
    'oro.footer.ios': '适用于 IOS',
    'oro.footer.android': '适用于 Android',
    'oro.profile.guest': '游客',
    'oro.profile.vipClub': 'VIP 俱乐部',
    'oro.profile.depositAmount': '存款金额：',
    'oro.profile.betAmount': '投注金额：',
    'oro.profile.deposit': '存款',
    'oro.profile.withdraw': '取款',
    'oro.profile.signOut': '退出登录',
    'oro.profile.signIn': '登录',
    'oro.profile.edit': '编辑',
    'oro.profile.copy': '复制',
    'oro.profile.copied': '复制成功',
    'oro.profile.copyFail': '复制失败',
    'oro.profile.back': '返回',
    'oro.profile.quick.tx': '交易',
    'oro.profile.quick.bets': '投注',
    'oro.profile.quick.moves': '账变',
    'oro.profile.menu.notify': '通知',
    'oro.profile.menu.withdraw-account': '取款账户管理',
    'oro.profile.menu.offers': '我的优惠',
    'oro.profile.menu.my-profile': '我的资料',
    'oro.profile.menu.team': '团队中心',
    'oro.profile.menu.tickets': '优惠',
    'oro.profile.menu.settings': '设置',
    'oro.profile.menu.support': '在线客服',
    'oro.profile.menu.language': '语言',
    'oro.auth.account': '请输入账号',
    'oro.auth.phone': '请输入10位手机号',
    'oro.auth.password': '请输入密码',
    'oro.auth.promo': '邀请码',
    'oro.auth.forgot': '忘记密码？',
    'oro.auth.terms': '我确认已满 18 岁并已阅读',
    'oro.auth.termsLink': '服务条款',
    'oro.auth.gift': '注册即送礼',
    'oro.auth.giftLead': 'Recibe',
    'oro.auth.giftTail': 'Bonos',
    'oro.auth.hasAccount': '已有账号？',
    'oro.auth.noAccount': '还没有账号？',
    'oro.auth.orLogin': '或使用以下方式登录',
    'oro.auth.support': '在线客服',
    'oro.auth.guest': '游客模式继续',
    'oro.guestBind.gift': '绑定成功赠送 {n} 积分',
    'oro.guestBind.ok': '绑定成功',
    'oro.guestBind.hint': '6-16 位。绑定后可用手机号和这个密码登录。',
    'oro.guestBind.submit': '确认绑定',
    'oro.guestBind.submitting': '绑定中',
    'oro.guestBind.close': '关闭',
    'oro.auth.err.account': '请输入账号',
    'oro.auth.err.password': '密码须为 6-16 位',
    'oro.auth.err.phone': '请输入 10 位手机号',
    'oro.auth.err.adult': '请确认已满 18 岁',
    'oro.auth.contactSupport': '请联系客服',
    'oro.auth.googleUnavailable': 'Google 登录暂不可用。',
    'oro.auth.smsLogin': '验证码登录',
    'oro.auth.passwordLogin': '密码登录',
    'oro.auth.smsCode': '请输入验证码',
    'oro.auth.sendCode': '发送验证码',
    'oro.auth.smsFail': '验证码发送失败',
    'oro.auth.err.code': '请输入验证码',
    'oro.auth.err.codeLength': '请输入6位验证码',
    'auth.sessionExpired': '登录已过期，请重新登录',
    'oro.lang.short.es-MX': 'MX',
    'oro.lang.short.en-US': 'EN',
    'oro.lang.short.zh-CN': '简',
    'oro.lang.short.zh-TW': '繁',
  },
  'zh-TW': {
    'oro.tab.menu': '選單',
    'oro.tab.casino': '娛樂場',
    'oro.tab.deposit': '存款',
    'oro.tab.activity': '活動',
    'oro.tab.profile': '我的',
    'oro.nav.aria': '導覽',
    'oro.menu.close': '關閉選單',
    'oro.menu.casino': '娛樂場',
    'oro.menu.vip': 'VIP 等級',
    'oro.menu.promo': '優惠',
    'oro.menu.affiliate': '代理中心',
    'oro.menu.telegram': 'Telegram',
    'oro.menu.chat': '線上客服',
    'oro.lobby.lobby': '大廳',
    'oro.lobby.estudios': '場館',
    'oro.lobby.providers': '場館',
    'oro.lobby.games': '遊戲',
    'oro.lobby.all': '全部',
    'oro.lobby.favoritos': '收藏',
    'oro.lobby.popular': '熱門',
    'oro.lobby.popular-alt': '熱門',
    'oro.lobby.nuevos': '新品',
    'oro.lobby.slots': '老虎機',
    'oro.lobby.live': '真人',
    'oro.lobby.sports': '體育',
    'oro.lobby.fishing': '捕魚',
    'oro.header.login': '登入',
    'oro.header.register': '註冊',
    'oro.header.deposit': '存款',
    'oro.header.profile': '我的',
    'oro.header.redeem': '兌換碼',
    'oro.footer.related': '相關連結',
    'oro.footer.about': '關於我們',
    'oro.footer.related.vip': 'VIP 俱樂部',
    'oro.footer.related.pwa': '加入主畫面',
    'oro.footer.about.rules': '使用者規則',
    'oro.footer.about.privacy': '隱私權政策',
    'oro.footer.about.disclaimer': '免責聲明',
    'oro.footer.about.kyc': '身分驗證政策（KYC）',
    'oro.footer.about.aml': '防制洗錢政策',
    'oro.footer.legal':
      '嚴禁未成年人賭博。請記住，投注僅供娛樂。orocasino.mx 不面向兒童或未滿 18 歲人士。若未滿 18 歲（或未達所在國家／地區的法定博彩年齡），請勿進入本站。未成年人在提交任何個人資訊（如姓名、電子郵件或電話）前須獲得父母許可。博彩可能成癮，請理性遊戲。欲了解更多資訊，請造訪我們的[負責任博彩]頁面。',
    'oro.footer.copyright': 'Copyright ©2019-2024. 保留所有權利。保留所有權利。',
    'oro.footer.app': '應用',
    'oro.footer.ios': '適用於 IOS',
    'oro.footer.android': '適用於 Android',
    'oro.profile.guest': '訪客',
    'oro.profile.vipClub': 'VIP 俱樂部',
    'oro.profile.depositAmount': '存款金額：',
    'oro.profile.betAmount': '投注金額：',
    'oro.profile.deposit': '存款',
    'oro.profile.withdraw': '取款',
    'oro.profile.signOut': '登出',
    'oro.profile.signIn': '登入',
    'oro.profile.edit': '編輯',
    'oro.profile.copy': '複製',
    'oro.profile.copied': '複製成功',
    'oro.profile.copyFail': '複製失敗',
    'oro.profile.back': '返回',
    'oro.profile.quick.tx': '交易',
    'oro.profile.quick.bets': '投注',
    'oro.profile.quick.moves': '帳變',
    'oro.profile.menu.notify': '通知',
    'oro.profile.menu.withdraw-account': '取款帳戶管理',
    'oro.profile.menu.offers': '我的優惠',
    'oro.profile.menu.my-profile': '我的資料',
    'oro.profile.menu.team': '團隊中心',
    'oro.profile.menu.tickets': '優惠',
    'oro.profile.menu.settings': '設定',
    'oro.profile.menu.support': '線上客服',
    'oro.profile.menu.language': '語言',
    'oro.auth.account': '請輸入帳號',
    'oro.auth.phone': '請輸入10位手機號',
    'oro.auth.password': '請輸入密碼',
    'oro.auth.promo': '邀請碼',
    'oro.auth.forgot': '忘記密碼？',
    'oro.auth.terms': '我確認已滿 18 歲並已閱讀',
    'oro.auth.termsLink': '服務條款',
    'oro.auth.gift': '註冊即送禮',
    'oro.auth.giftLead': 'Recibe',
    'oro.auth.giftTail': 'Bonos',
    'oro.auth.hasAccount': '已有帳號？',
    'oro.auth.noAccount': '還沒有帳號？',
    'oro.auth.orLogin': '或使用以下方式登入',
    'oro.auth.support': '線上客服',
    'oro.auth.guest': '訪客模式繼續',
    'oro.guestBind.gift': '綁定成功贈送 {n} 積分',
    'oro.guestBind.ok': '綁定成功',
    'oro.guestBind.hint': '6-16 位。綁定後可用手機號和這個密碼登入。',
    'oro.guestBind.submit': '確認綁定',
    'oro.guestBind.submitting': '綁定中',
    'oro.guestBind.close': '關閉',
    'oro.auth.err.account': '請輸入帳號',
    'oro.auth.err.password': '密碼須為 6-16 位',
    'oro.auth.err.phone': '請輸入 10 位手機號',
    'oro.auth.err.adult': '請確認已滿 18 歲',
    'oro.auth.contactSupport': '請聯繫客服',
    'oro.auth.googleUnavailable': 'Google 登入暫不可用。',
    'oro.auth.smsLogin': '驗證碼登入',
    'oro.auth.passwordLogin': '密碼登入',
    'oro.auth.smsCode': '請輸入驗證碼',
    'oro.auth.sendCode': '發送驗證碼',
    'oro.auth.smsFail': '驗證碼發送失敗',
    'oro.auth.err.code': '請輸入驗證碼',
    'oro.auth.err.codeLength': '請輸入6位驗證碼',
    'auth.sessionExpired': '登入已過期，請重新登入',
    'oro.lang.short.es-MX': 'MX',
    'oro.lang.short.en-US': 'EN',
    'oro.lang.short.zh-CN': '簡',
    'oro.lang.short.zh-TW': '繁',
  },
};
